import React from "react";
import { DetailCardsWrapper } from "./styles";
import SplitDetailCard from "components/Dashboard/SplitDetailCard";

const DashboardHeader = ({totalClients, clientInProgress}) => {
  const getCardDetails = (totalClients, clientsInProgress) => {
    const result = [];
    if (totalClients) {
      result.push({
        number: totalClients,
        title: "Total Active Clients",
      });
    }
    if (clientsInProgress) {
      result.push({
        number: clientsInProgress,
        title: "Clients in Progress",
      });
    }
    return result;
  };
  return (
    <DetailCardsWrapper>
      <SplitDetailCard
        width="35rem"
        details={getCardDetails(totalClients, clientInProgress)}
      />
    </DetailCardsWrapper>
  );
};

export default DashboardHeader;
